import { render, staticRenderFns } from "./asdpeixun.vue?vue&type=template&id=279403c2&"
import script from "./asdpeixun.vue?vue&type=script&lang=js&"
export * from "./asdpeixun.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports